import { Component } from '@angular/core';
import {CoreComponent} from '../../core/core.component';
import {BlockUI, NgBlockUI} from 'ng-block-ui';
import {ActivatedRoute, Router} from '@angular/router';
import {NgbActiveModal, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {Results} from '../../core/results';
import {WithdrawReasonComponent} from './withdraw-reason/withdraw-reason.component';
import {WithdrawReason} from './withdraw-reason/withdraw-reason';
import {WithdrawReasonsService} from './withdraw-reasons.service';
import {HttpErrorResponse} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {Meta, Title} from '@angular/platform-browser';
import {GoogleAnalyticsService} from 'ngx-google-analytics';
declare var bootbox: any;
@Component({
  selector: 'app-withdraw-reasons',
  templateUrl: './withdraw-reasons.component.html',
  styleUrls: ['./withdraw-reasons.component.scss']
})
export class WithdrawReasonsComponent extends CoreComponent<WithdrawReason> {
  @BlockUI() blockUI: NgBlockUI;
  constructor(protected servicesService: WithdrawReasonsService, public route: ActivatedRoute,private modalService: NgbModal,
              public activeModal: NgbActiveModal,protected gaService: GoogleAnalyticsService,
              private router: Router, private matSnackBar: MatSnackBar,public meta: Meta, public title: Title) {
    super(servicesService,route);
    this.title.setTitle('Withdraw Reasons');
  }

  public search() {
    this.blockUI.start();
    this.servicesService.search(this.currentPage, this.perPage, this.order, this.orderBy, this.keyword)
      .subscribe((data: Results<WithdrawReason>) => {
        this.results = data;
        this.blockUI.stop();
      }, (error: HttpErrorResponse) => {
        this.blockUI.stop();
        this.gaService.exception(error.error?.message, true);

        if (error.status === 401) {
          this.activeModal.close();
          this.router.navigate(['/']);
          this.matSnackBar.open('Your session has expired', 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }else {
          this.blockUI.stop();
          this.matSnackBar.open(error.error.message, 'Okay', {
            duration: 5000,
            horizontalPosition: 'center',
            verticalPosition: 'top',
          });
        }
      });
  }

  remove(item: WithdrawReason){
    const that = this;
    bootbox.confirm({
      title: 'Are you sure you want to delete?',
      message: '<strong>'+item.name+'</strong>',
      callback: function(result) {
        if (result === null) {
        } else if (result === true) {

          that.servicesService.delete(item.id).subscribe(()=>{
            that.search();
          });
        }
      }
    });
  }
  newItem() {
    this.item = new WithdrawReason();
    this.open(this.item);
  }
  open(item: WithdrawReason) {
    const modalRef = this.modalService.open(WithdrawReasonComponent, {fullscreen:true, modalDialogClass:'animate-bottom'});
    modalRef.componentInstance.item= item;
    modalRef.componentInstance.name = 'World';
    modalRef.closed.subscribe(()=>{
      this.search();
    });
  }
}
